import React from "react";
import { message, Modal } from "antd";
import { Dropdown, Space, Form } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import "./Style.css";
import { Input } from "antd";
import { Button } from "antd";
import { useState, useRef, useEffect } from "react";
import TextArea from "antd/lib/input/TextArea";

const RemarksComponent  = (props) => {
    const {
        resData,
        remarks,
        setRemarks,
        isHistory,
        setIsHistory,
        setRemarkComment,
        handelAddRemarks
    } = props;
    const [addRemarks, setAddRemarks] = useState('');
    const remarksEndRef = useRef(null);

    const handleModalCancel = () =>{
        setRemarks(false);
    }

    const handleSubmit = () => {
        if (addRemarks.trim()) {
            handelAddRemarks(addRemarks);
            setAddRemarks('');
        }
    }

    const handleChange = (event) =>{
        // setAddRemarks(event.target.value);
        const value = event.target.value;
    // const words = value.trim().split(/\s+/);
    if (value.length <= 250) {
        setAddRemarks(value);
    } else {
        // setAddRemarks(value.slice(0, 250).join(' '));
        message.error("You can only enter a maximum of 250 characters.");
    }
    }

    useEffect(() => {
        if (remarksEndRef.current) {
            remarksEndRef.current.scrollTop = remarksEndRef.current.scrollHeight;
        }
    }, [resData]);

    return(
    <>
        <Modal
            className="remarksModal"
            open={remarks}
            width={300}
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0 , 0.1)' }}
            footer={[]}
            onCancel={handleModalCancel}
        > 
            <div
                ref={remarksEndRef}
                style={{
                    width: "100%",
                    maxHeight: "450px",
                    overflowY: "auto",
                    marginTop: "10px",
                }}
            >
                {Array.isArray(resData)
                    ? resData.map((remark, idx) => (
                        <div key={idx}>{remark}</div>
                    ))
                    : resData}
            </div> 
            { isHistory === true ? null : (
                <div className="inputContainer" style={{display:"flex", width:"100%"}} >
                    <Form.Item style={{marginBottom:"0", width:"90%"}}>
                        <TextArea
                            className="textArea-input"
                            style={{width:"100%", marginTop:10}}
                            placeholder="Enter Remarks"
                            onChange={handleChange}
                            value={addRemarks}
                            autoSize={{ minRows: 3, maxRows: 5 }}
                        />
                    </Form.Item>
                    <Button className="btn-remark" style={{border:"none", width:"10%"}} onClick={handleSubmit}>
                        <ArrowRightOutlined />
                    </Button>
                </div>
            )}
        </Modal> 
    </>
    )
}

export default RemarksComponent;